"use client";

import { createSupabaseBrowserClient } from "@/lib/supabase/client";

export const supabase = createSupabaseBrowserClient();
